/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ConsigneeCheckinResponse } from '../models/consignee-checkin-response';
import { postConsigneeAddonsCheckinV3 } from '../fn/checkins-v-3/post-consignee-addons-checkin-v-3';
import { PostConsigneeAddonsCheckinV3$Params } from '../fn/checkins-v-3/post-consignee-addons-checkin-v-3';

@Injectable({ providedIn: 'root' })
export class CheckinsV3Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postConsigneeAddonsCheckinV3()` */
  static readonly PostConsigneeAddonsCheckinV3Path = '/organization-sites/{organizationSiteKey}/consignee/checkins';

  /**
   * Start a consignee checkin (v3).
   *
   * Wraps the basic backend checkin-start endpoint. Before the checkin is
   * created it enforces the addons rule that a checkin whose delivery
   * notes are ALL part of a bundle group (Mappengruppe) must be handled
   * via the bundle group checkin flow, not the plain checkin: if every
   * requested delivery note belongs to a bundle group, the endpoint
   * returns 409 and does NOT start a checkin in Basic. A request with at
   * least one ungrouped delivery note is passed through and the created
   * checkin document is returned unchanged.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postConsigneeAddonsCheckinV3()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postConsigneeAddonsCheckinV3$Response(params: PostConsigneeAddonsCheckinV3$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsigneeCheckinResponse>> {
    const obs = postConsigneeAddonsCheckinV3(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Start a consignee checkin (v3).
   *
   * Wraps the basic backend checkin-start endpoint. Before the checkin is
   * created it enforces the addons rule that a checkin whose delivery
   * notes are ALL part of a bundle group (Mappengruppe) must be handled
   * via the bundle group checkin flow, not the plain checkin: if every
   * requested delivery note belongs to a bundle group, the endpoint
   * returns 409 and does NOT start a checkin in Basic. A request with at
   * least one ungrouped delivery note is passed through and the created
   * checkin document is returned unchanged.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postConsigneeAddonsCheckinV3$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postConsigneeAddonsCheckinV3(params: PostConsigneeAddonsCheckinV3$Params, context?: HttpContext): Observable<ConsigneeCheckinResponse> {
    const resp = this.postConsigneeAddonsCheckinV3$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConsigneeCheckinResponse>): ConsigneeCheckinResponse => r.body)
    );
  }

}
